<template>
    <div>


        <div class="panel-toolbar pr-3 pb-2 align-self-end">
            <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_prod()">
                <span class="fal  fa-eject mr-1"></span>
                {{__t('ADD_PAYMENT')}}
            </button>
        </div>

        <div class="border bg-light rounded-top" v-if="payments.length > 0">
            <div id="js_list_accordion" class="accordion accordion-hover accordion-clean js-list-filter">
                <div class="card border-top-left-radius-0 border-top-right-radius-0" v-for="payment in payments">
                    <div class="card-header" v-on:click="edit_type(payment)">
                        <a href="javascript:void(0);" class="card-title collapsed pt-2 pb-2" >
                            <i class="fa fa-fog pr-4"></i>

                            <div>
                                <div>
                                    {{payment.title}}
                                </div>
                                <div class="small badge border border-success">
                                    POS_ID: {{payment.uniq_id}}
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "organization_payments",

    props : {
        org : {
            type : Object
        }
    },
    data() {
        return {
            payments: [],
        }
    },

    created() {
        EventBus.$on('reload_org_type',this.check_load);
        this.load_payments();
    },

    methods : {

        check_load(type) {
            if(type == 'payment') {
                this.load_payments();
            }
        },

        edit_type(item) {
            EventBus.$emit('make_type_org','payment',item,parseInt(this.org.id));
        },

        add_prod() {
            EventBus.$emit('make_type_org','payment',null,parseInt(this.org.id));
        },

        async load_payments() {
            this.payments = [];
            await api.get('/internal/v1/catalog/organizations/'+ parseInt(this.org.id) +'/payments',{}).then(({data}) => {
                if (data.status === "operation_success") {
                    this.payments = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    }
}
</script>

<style scoped>

</style>
